import firebaseService from 'app/services/firebaseService';
import jwtService from 'app/services/jwtService';
import {setUserData} from './user.actions';
import * as Actions from 'app/store/actions';
import history from '@history';

export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export function submitLogin({email, password})
{
    return (dispatch) =>
        jwtService.signInWithEmailAndPassword(email, password)
            .then((user) => {
                //debugger
                    dispatch(setUserData(user));
                    // No confiar en el redirectUrl que haya quedado guardado de un
                    // intento de acceso anterior (ej. a una página protegida antes
                    // de loguearse): siempre entrar por "/" para que zroute decida
                    // el destino según el rol recién obtenido.
                    history.replace('/');

                    return dispatch({
                        type: LOGIN_SUCCESS
                    });
                }
            )
            .catch(error => {
                return dispatch({
                    type   : LOGIN_ERROR,
                    payload: error
                });
            });
}

export function submitCompany(email, companyId, perfil)
{
    return (dispatch) =>
        jwtService.signInWithCompany(email, companyId, perfil)
            .then((result) => {
                    if (result.requiresProfile) {
                        return result;
                    }

                    dispatch(setUserData(result.user));
                    history.replace('/');

                    dispatch({
                        type: LOGIN_SUCCESS
                    });

                    return result;
                }
            )
            .catch(error => {
                return dispatch({
                    type   : LOGIN_ERROR,
                    payload: error
                });
            });
}

// Cambio de empresa activa desde dentro de la app (usuario ya logueado):
// reusa el token vigente en vez de volver a pasar por credenciales/email.
// Misma lógica de requiresProfile que submitCompany.
export function changeCompany(companyId, perfil)
{
    return (dispatch) =>
        jwtService.switchCompany(companyId, perfil)
            .then((result) => {
                if (result.requiresProfile) {
                    return result;
                }

                dispatch(setUserData(result.user));

                return result;
            });
}

export function submitLoginWithFireBase({username, password})
{
    return (dispatch) =>
        firebaseService.auth && firebaseService.auth.signInWithEmailAndPassword(username, password)
            .then(() => {
                return dispatch({
                    type: LOGIN_SUCCESS
                });
            })
            .catch(error => {
                const usernameErrorCodes = [
                    'auth/email-already-in-use',
                    'auth/invalid-email',
                    'auth/operation-not-allowed',
                    'auth/user-not-found',
                    'auth/user-disabled'
                ];
                const passwordErrorCodes = [
                    'auth/weak-password',
                    'auth/wrong-password'
                ];

                const response = {
                    username: usernameErrorCodes.includes(error.code) ? error.message : null,
                    password: passwordErrorCodes.includes(error.code) ? error.message : null
                };

                if ( error.code === 'auth/invalid-api-key' )
                {
                    dispatch(Actions.showMessage({message: error.message}));
                }

                return dispatch({
                    type   : LOGIN_ERROR,
                    payload: response
                });
            });
}
